import {
  FirestoreCollectionProsessorOptions,
  createFirestoreCollectionProsessor,
} from "../firebase/firestore";

import { SheetFieldSchema } from "./SheetFieldSchema";
import { TypeSchemaRaw, encodeTypeSchema, parseTypeSchema } from "./TypeSchema";

export type TadSheetFieldSchema = SheetFieldSchema;

type TadSheetFieldSchemaRaw = {
  id: string;
  display_name: string;
  name: string;
  is_required: boolean;
  is_unique: boolean;
  sort: number;
  description: string | null;
} & TypeSchemaRaw;

const processorOptions: FirestoreCollectionProsessorOptions<
  TadSheetFieldSchema,
  TadSheetFieldSchemaRaw,
  Record<"tadSheetId", string>
> = {
  getCollectionPath: ({ organizationId, tadSheetId }) =>
    `/app/spreadsheet_ui/v/1/organizations/${organizationId}/tad_sheets/${tadSheetId}/sheet_field_schemas`,
  toFirestore: ({
    id,
    displayName,
    name,
    isRequired,
    isUnique,
    type,
    typeFields,
    typeParameters,
    sort,
    description,
  }) => ({
    id,
    display_name: displayName,
    name,
    is_required: isRequired,
    is_unique: isUnique,
    sort,
    description,
    ...encodeTypeSchema({ type, typeFields, typeParameters }),
  }),
  fromFirestore: ({
    id,
    display_name,
    name,
    is_required,
    is_unique,
    sort,
    field_type,
    field_type_fields,
    field_type_parameters,
    description,
  }) => ({
    id,
    displayName: display_name,
    name,
    isRequired: is_required,
    isUnique: is_unique,
    sort,
    description,
    ...parseTypeSchema({
      field_type,
      field_type_fields,
      field_type_parameters,
    }),
  }),
};

/**
 * TADS のシートフィールドスキーマを購読する。`tadSheetId` に `undefined` を渡すと
 * `useItems` 側のガードで購読が行われないので、条件分岐なしで呼び出してよい。
 */
export const {
  useGetAll: useGetTadSheetFieldSchemas,
  useSet: useSetTadSheetFieldSchema,
  useDelete: useDeleteTadSheetFieldSchema,
  useItems: useTadSheetFieldSchemas,
  useSomeItems: useSomeTadSheetFieldSchemas,
} = createFirestoreCollectionProsessor(processorOptions);
